import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
// components
// middlewares
// import AuthMiddleware from '../../../../reducers/auth/middleware';
import { Navigate } from 'react-router-dom';
import VehicleMiddleware from '../../../../middleware/modules/master/vehicle';
import Vehicle from '../../../../components/modules/master/vehicle';
import useScript from '../../../../components/utilities/useScript';

const mapStateToProps = ({ auth,vehicle }) => ({
  isAuthenticated: auth.isAuthenticated,
  isProcessing: auth.isProcessing,
  isRegistered: auth.isRegistered,
  isError: auth.isError,
  errorMessage: auth.errorMessage,
  datalist:vehicle.data
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    VehicleList: customer =>VehicleMiddleware.list(customer)
  }, dispatch);
};
class VehicleContainer extends Component {
  
  static propTypes = {
    isAuthenticated: PropTypes.bool,
    isProcessing: PropTypes.bool,
    isRegistered: PropTypes.bool,
    isError: PropTypes.bool,
    errorMessage: PropTypes.object,
    datalist: PropTypes.object,
    VehicleList: PropTypes.func.isRequired
  }

  static defaultProps = {
    isAuthenticated: false,
    isProcessing: false,
    isRegistered: false,
    isError: false,
    errorMessage: {}
  }
  componentWillMount() {
    var host=process.env.APP_URL
    const search = {
      limit: 10,
    };
   this.props.VehicleList(search);
  }
  render() {
    const { isAuthenticated, isProcessing, isRegistered, isError, errorMessage, VehicleList ,datalist} = this.props;
    // if(isAuthenticated){
    //   return <Navigate
    //         to='/'
    //       />
    // }
    return (
      <Vehicle 
        search={VehicleList}
        data={datalist}
        isProcessing={isProcessing}
        isError={isError}
        errorMessage={errorMessage}
      />
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(VehicleContainer);
